import {Injectable} from '@angular/core';
import {MessageService} from './message.service';
import {catchError} from 'rxjs/operators';
import {TeamFormInterface, TeamInfo, UserById} from '@core/models';
import {BaseApiService} from '@core/api-services';
import {EMPTY, lastValueFrom} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidationHelper} from '@core/helpers';

@Injectable({
    providedIn: 'root'
})
export class LeaderboardService {

    constructor(
        private _baseApiService: BaseApiService,
        private _messageService: MessageService,
        private _fb: FormBuilder) {
    }

    private getTeamMembers(teamId: string, game_code: string): Promise<TeamInfo> {
        return lastValueFrom(this._baseApiService.gameApiService.getTeamMembers(teamId, game_code)
            .pipe(
                catchError((err) => {
                    this._messageService.openConfirmModal({
                        msg: err.error.message,
                        isFailure: true,
                        isConfirm: false
                    });
                    return EMPTY;
                })
            ));
    }

    private getCaptainById(captainId: string): Promise<UserById> {
        return lastValueFrom(this._baseApiService.staffService.getMemberById(captainId)
            .pipe(
                catchError((err) => {
                    this._messageService.openConfirmModal({
                        msg: err.error.message,
                        isFailure: true,
                        isConfirm: false
                    });
                    return EMPTY;
                }))
        );
    }


    async getTeamDetails(teamId: string, game_code: string): Promise<TeamInfo> {
        let teamDetails = await this.getTeamMembers(teamId, game_code);
        if (!teamDetails.team_members.length) {
            const captainDetails = await this.getCaptainById(teamDetails.captain_id);
            captainDetails.image = captainDetails.photo;
            teamDetails = {team_members: [captainDetails], captain_id: captainDetails.user_id, team_id: teamId};
        }

        return teamDetails;
    }

    generateTeamFormGroup({team_name,team_name_lowercase, image, bonus,bonus_view, score, disabled, player_numbers_survey}: TeamFormInterface): FormGroup {
        return this._fb.group({
          team_name: [{value: team_name, disabled}, [
                Validators.required,
                ValidationHelper.noWhitespaceValidator,
                ValidationHelper.minLengthValidator,
                Validators.maxLength(30)
            ]],
            team_name_lowercase,
            image,
            score,
            bonus,
            bonus_view,
            player_numbers_survey: [player_numbers_survey, [
                Validators.required,
                ValidationHelper.patternValidator('^[1-9]{1}[0-9]*$'),
                Validators.maxLength(6)
            ]],
        });
    }

}
